module.exports = __webpack_public_path__ + "media/packs/images/flags/SB-5f98b526753ec5ff00ccc39861f591a2.svg";